import { createInertiaApp } from '@inertiajs/vue3'
import { createPinia } from 'pinia'
import axios from 'axios'
import { axiosAdapter, http } from '@inertiajs/core'
import AppIcon from '~conciergeUiCommons/components/AppIcon.vue'
import Popper from 'vue3-popper'
import '~conciergeUiCommons/libs/fontawesome.js'
import { i18nVue } from 'laravel-vue-i18n'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import { domPurifyOptions } from '~conciergeUiCommons/libs/dompurify'
import { configureInertiaSentry, inertiaRoutingInstrumentation } from '~conciergeUiCommons/inertia-sentry';
import { initAnalytics } from '~conciergeUiCommons/inertia-analytics';

const pinia = createPinia()
pinia.use(({ store }) => {
    store.service = 'conciergeForm'
    // make sure your bundler handles this. webpack and vite should do it by default
    if (process.env.NODE_ENV === 'development') {
        store._customProperties.add('service')
    }
})

createInertiaApp({
    defaults: {
        visitOptions: () => {
            return { viewTransition: true }
        },
    },
    http: axiosAdapter(axios),
    pages: { path: './Concierge', lazy: false },
    withApp(app, { page }) {
        const captchaKey = page.props.recaptcha_site_key;
        configureInertiaSentry(app, inertiaRoutingInstrumentation);
        app.use(i18nVue, {
            // the only way to make it work with vite is to return a promise
            resolve: async (lang) => ({ default: page.props.languages[lang] }),
            fallbackLang: document.documentElement.lang,
            fallbackMissingTranslations: true,

        })
        app
            .component('Popper', Popper)
            .component('AppIcon', AppIcon)
            .use(pinia)
            .use(VueReCaptcha, { siteKey: captchaKey })
            .use(VueDOMPurifyHTML, domPurifyOptions)

        app.config.globalProperties.$route = route
    }
})

initAnalytics('u5k3t5xl9n', 'GTM-5RL9C7ZM')